export default function MutedNoneText() {
  return <span className="text-muted">None</span>;
}
